var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 119,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fx0",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%",
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "discrete",
    tableValues: "0.000000 0.000000"
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "discrete",
    tableValues: "0.000000 0.000000"
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "discrete",
    tableValues: "0.000000 0.000000"
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.4,
    intercept: 0
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "1.777778 1.777778"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 254,
    width: 417,
    height: 119
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 254,
    width: 417,
    height: 119
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666656,
    y: 0.666672,
    width: 415.667,
    height: 117.667
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436,
    y: 258,
    width: 404,
    height: 106
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436,
    y: 258,
    width: 404,
    height: 106
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "translate(-432 -254)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    filter: "url(#fx0)",
    transform: "translate(432 254)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.3579-239.749 78.3579-140.072 124.55-140.072C135.147-140.072 142.908-142.409 147.833-147.085 152.757-151.76 156.03-161.017 157.651-174.856L164.57-174.856 164.57-89.0176 157.651-89.0176C157.526-98.8669 156.248-106.098 153.817-110.711 151.386-115.324 148.02-118.784 143.719-121.09 139.417-123.397 133.028-124.55 124.55-124.55L78.3579-124.55 78.3579-44.8828C78.3579-32.0413 79.1683-23.5635 80.7891-19.4492 82.0358-16.3324 84.654-13.6519 88.6436-11.4077 94.1292-8.41553 99.8643-6.91943 105.849-6.91943L115.012-6.91943 115.012 0 6.17139 0 6.17139-6.91943 15.1479-6.91943C25.6206-6.91943 33.2257-9.97396 37.9634-16.083 40.9556-20.0726 42.4517-29.6725 42.4517-44.8828L42.4517-208.705C42.4517-221.547 41.6413-230.024 40.0205-234.139 38.7738-237.256 36.2179-239.936 32.353-242.18 26.992-245.172 21.257-246.668 15.1479-246.668L6.17139-246.668 6.17139-253.588 194.866-253.588 197.297-197.858 190.752-197.858C187.51-209.702 183.739-218.399 179.438-223.947 175.136-229.495 169.838-233.515 163.542-236.009 157.246-238.502 147.49-239.749 134.274-239.749Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(0.315625 0 0 0.317153 22.4228 102)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.9663 96.604C99.812 91.6752 103.641 87.3839 108.214 83.997L119.334 99.0122C116.818 100.875 114.713 103.235 113.147 105.946Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 6.82843 -56.4108)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.214 83.997C117.46 77.1504 129.131 74.4465 140.445 76.5302L137.06 94.9056C130.838 93.7596 124.419 95.2468 119.334 99.0122Z",
    fill: "#A6A6A6",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 6.82843 -56.4108)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.445 76.5299C157.725 79.7124 171.131 93.4275 173.919 110.776L155.472 113.741C153.938 104.199 146.565 96.6557 137.061 94.9056Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 6.82843 -56.4108)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.919 110.776C177.042 130.202 166.101 149.152 147.716 156.161L141.06 138.703C151.171 134.848 157.189 124.425 155.472 113.741Z",
    fill: "#D9D9D9",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 6.82843 -56.4108)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M147.716 156.161C126.289 164.331 102.297 153.583 94.1276 132.156 89.6766 120.482 90.7195 107.424 96.9663 96.604L113.147 105.946C106.841 116.869 110.584 130.835 121.506 137.142 127.457 140.577 134.639 141.151 141.06 138.703Z",
    fill: "#F2F2F2",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 6.82843 -56.4108)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.552-70.1294 225.723-68.8203 204.03 0 7.66748 0 7.66748-6.91943 17.2051-6.91943C27.9271-6.91943 35.5946-10.4103 40.2075-17.3921 42.8257-21.3817 44.1348-30.6076 44.1348-45.0698L44.1348-208.705C44.1348-224.539 42.3893-234.45 38.8984-238.44 34.0361-243.926 26.805-246.668 17.2051-246.668L7.66748-246.668 7.66748-253.588 122.493-253.588 122.493-246.668C109.028-246.793 99.5837-245.546 94.1604-242.928 88.7371-240.31 85.028-237.006 83.0332-233.017 81.0384-229.027 80.041-219.489 80.041-204.404L80.041-45.0698C80.041-34.7218 81.0384-27.6154 83.0332-23.7505 84.5293-21.1323 86.8358-19.1999 89.9526-17.9531 93.0695-16.7064 102.794-16.083 119.126-16.083L137.641-16.083C157.09-16.083 170.742-17.5168 178.596-20.3843 186.451-23.2518 193.619-28.3323 200.103-35.6257 206.586-42.9192 213.069-54.4204 219.552-70.1294ZM352.191-6.91943 352.191 0 243.538 0 243.538-6.91943 252.514-6.91943C262.987-6.91943 270.592-9.97396 275.33-16.083 278.322-20.0726 279.818-29.6725 279.818-44.8828L279.818-208.705C279.818-221.547 279.007-230.024 277.387-234.139 276.14-237.256 273.584-239.936 269.719-242.18 264.234-245.172 258.499-246.668 252.514-246.668L243.538-246.668 243.538-253.588 352.191-253.588 352.191-246.668 343.028-246.668C332.68-246.668 325.137-243.614 320.399-237.505 317.283-233.515 315.724-223.915 315.724-208.705L315.724-44.8828C315.724-32.0413 316.534-23.5635 318.155-19.4492 319.402-16.3324 322.02-13.6519 326.01-11.4077 331.371-8.41553 337.043-6.91943 343.028-6.91943Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(0.315625 0 0 0.317153 185.11 102)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M308.006 96.604C310.852 91.6752 314.681 87.3839 319.255 83.997L330.374 99.0122C327.859 100.875 325.753 103.235 324.188 105.946Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 6.82843 -56.4108)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M319.255 83.997C328.499 77.1504 340.171 74.4465 351.486 76.5302L348.1 94.9056C341.879 93.7596 335.459 95.2468 330.374 99.0122Z",
    fill: "#A6A6A6",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 6.82843 -56.4108)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M351.483 76.5299C368.764 79.7124 382.171 93.4275 384.958 110.776L366.513 113.741C364.979 104.199 357.606 96.6557 348.1 94.9056Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 6.82843 -56.4108)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M384.958 110.776C388.083 130.202 377.14 149.152 358.755 156.161L352.099 138.703C362.211 134.848 368.23 124.425 366.513 113.741Z",
    fill: "#D9D9D9",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 6.82843 -56.4108)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M358.755 156.161C337.331 164.331 313.337 153.583 305.168 132.156 300.717 120.482 301.759 107.424 308.006 96.604L324.188 105.946C317.882 116.869 321.625 130.835 332.546 137.142 338.498 140.577 345.679 141.151 352.099 138.703Z",
    fill: "#F2F2F2",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 6.82843 -56.4108)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Times New Roman,Times New Roman_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 383,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(0.315625 0 0 0.317153 451.594 353)"
  }, "F"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.9663 96.604C99.812 91.6752 103.641 87.3839 108.214 83.997L119.334 99.0122C116.818 100.875 114.713 103.235 113.147 105.946Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 436 194.761)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.214 83.997C117.46 77.1504 129.131 74.4465 140.445 76.5302L137.06 94.9056C130.838 93.7596 124.419 95.2468 119.334 99.0122Z",
    fill: "#A6A6A6",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 436 194.761)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.445 76.5299C157.725 79.7124 171.131 93.4275 173.919 110.776L155.472 113.741C153.938 104.199 146.565 96.6557 137.061 94.9056Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 436 194.761)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.919 110.776C177.042 130.202 166.101 149.152 147.716 156.161L141.06 138.703C151.171 134.848 157.189 124.425 155.472 113.741Z",
    fill: "#D9D9D9",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 436 194.761)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M147.716 156.161C126.289 164.331 102.297 153.583 94.1276 132.156 89.6766 120.482 90.7195 107.424 96.9663 96.604L113.147 105.946C106.841 116.869 110.584 130.835 121.506 137.142 127.457 140.577 134.639 141.151 141.06 138.703Z",
    fill: "#F2F2F2",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 436 194.761)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Times New Roman,Times New Roman_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 383,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(0.315625 0 0 0.317153 614.281 353)"
  }, "LI"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M308.006 96.604C310.852 91.6752 314.681 87.3839 319.255 83.997L330.374 99.0122C327.859 100.875 325.753 103.235 324.188 105.946Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 436 194.761)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M319.255 83.997C328.499 77.1504 340.171 74.4465 351.486 76.5302L348.1 94.9056C341.879 93.7596 335.459 95.2468 330.374 99.0122Z",
    fill: "#A6A6A6",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 436 194.761)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M351.483 76.5299C368.764 79.7124 382.171 93.4275 384.958 110.776L366.513 113.741C364.979 104.199 357.606 96.6557 348.1 94.9056Z",
    fill: "#BFBFBF",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 436 194.761)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M384.958 110.776C388.083 130.202 377.14 149.152 358.755 156.161L352.099 138.703C362.211 134.848 368.23 124.425 366.513 113.741Z",
    fill: "#D9D9D9",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 436 194.761)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M358.755 156.161C337.331 164.331 313.337 153.583 305.168 132.156 300.717 120.482 301.759 107.424 308.006 96.604L324.188 105.946C317.882 116.869 321.625 130.835 332.546 137.142 338.498 140.577 345.679 141.151 352.099 138.703Z",
    fill: "#F2F2F2",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1 0 0 1.00484 436 194.761)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolio);
export default __webpack_public_path__ + "static/media/Folio.10ae2e1f6368f309d1692fef1339ff15.svg";
export { ForwardRef as ReactComponent };